import { Trans } from '@lingui/react';
import { GqlMeetingStatus } from '../../../graphql/base-types.graphql';

export const MeetingStatusHuman = ({ children }: { children: GqlMeetingStatus }) => {
  switch (children) {
    case GqlMeetingStatus.InProgress: {
      return <Trans id="in progress" />;
    }
    case GqlMeetingStatus.Scheduled: {
      return <Trans id="scheduled" />;
    }
    case GqlMeetingStatus.Finished: {
      return <Trans id="completed" />;
    }
    default: {
      throw new Error('missing gql meeting status');
    }
  }
};
